import * as AssignmentsAPI from 'src/api/Assignments';
import { Document } from '../../../types/models';
import { OperationState } from './abstract';
import AsynchronousDocumentOperation from './asynchronous';

export default class UnsubmitSubmission extends AsynchronousDocumentOperation {
  readonly type = 'unsubmit-submission';

  // eslint-disable-next-line class-methods-use-this
  async postAndApply(
    document: Document,
    set: (fn: (document: Document) => Document) => void,
  ): Promise<OperationState> {
    if (document.submission?.id) {
      await AssignmentsAPI.unsubmit(document.submission.assignmentId, document.submission.id);
      set((doc) => ({
        ...doc,
        submission: doc.submission ? {
          ...doc.submission,
          status: 'returned',
        } : null,
      }));
      return 'saved';
    }
    return 'saved';
  }
}
